import { SORT, SEARCH, KIOSK_STATUS as KIOSK_STATUS_FILTER, KIOSK_MODELS } from 'constants/FilterConstants';
import { filterSliceAdapter } from 'modules/global/reducers/filterSliceAdapter';
import * as types from 'modules/kiosks/actionTypes';
import type { KioskModel, KioskStatus } from 'modules/kiosks/constants';
import { getPersistedFilters } from 'services/StateLoader';
import { createReducer } from 'utils/ReduxUtils';

export type KiosksFiltersReducer = {
  [SEARCH]: string | null;
  [KIOSK_MODELS]: Array<KioskModel>;
  [KIOSK_STATUS_FILTER]: Array<KioskStatus>;
  [SORT]: string;
};

const persistedFilters: Partial<KiosksFiltersReducer> = getPersistedFilters()?.filters?.kiosks ?? {};

const emptyState: KiosksFiltersReducer = {
  [SEARCH]: null,
  [KIOSK_MODELS]: [],
  [KIOSK_STATUS_FILTER]: [],
  [SORT]: 'name,ASC',
};

const filterAdapter = filterSliceAdapter(emptyState, persistedFilters);

export default createReducer(filterAdapter.getInitialState(), {
  [types.SET_KIOSKS_DASHBOARD_FILTER]: filterAdapter.setFilter,
  [types.CLEAR_KIOSKS_DASHBOARD_FILTER]: filterAdapter.resetFilters,
  [types.REMOVE_KIOSKS_DASHBOARD_FILTER]: filterAdapter.removeFilter,
});
